// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Task status.
 * @export
 * @enum {string}
 */
export enum RESTTaskItemStatus {
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Completed = 'Completed',
    WaitingOnSomeoneElse = 'WaitingOnSomeoneElse',
    Deferred = 'Deferred'
}

